import React from 'react';
import { noop, isEmpty } from 'lodash';
import classNames from 'classnames';
import { object, string, func, bool } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Dropdown } from '@fiverr-private/orca';
import { TEXT } from '../../../../constants';
import withImpressions from '../../hoc/withImpressions';
import Trigger from './Dropdown/Trigger';
import Entries from './Entries';
import './styles.scss';

const IMPRESSION_COMPONENT_CLASS = 'industry-selection-filter';

const impressionConfig = {
    DOMSelector: `.${IMPRESSION_COMPONENT_CLASS}`,
    getImpressionData: () => ({
        type: 'industry_filter_is_shown',
        page: {
            element: {
                type: TEXT,
            },
            component: {
                name: 'reviews_header',
            },
        },
        feature: {
            name: 'gig_reviews',
        },
    }),
};

const validate = (currentUserIndustries = {}, commonIndustries) =>
    !isEmpty(currentUserIndustries) || !isEmpty(commonIndustries);

const IndustrySelection = ({
    currentUserIndustries = {},
    commonIndustries = {},
    selected = null,
    onChange = noop,
    onClick = noop,
    multipleFilters = false,
}) => {
    if (!validate(currentUserIndustries, commonIndustries)) {
        return null;
    }

    return (
        <div className={classNames(IMPRESSION_COMPONENT_CLASS, 'col-12-xs')}>
            {!multipleFilters && (
                <div className="filter-industry-selection-text tbody-5">
                    <I18n k="reviews.industry.one" />
                </div>
            )}
            <Dropdown
                menu={
                    <Dropdown.Menu className="industries-filter-dropdown">
                        <Entries
                            headerKey="reviews.filters.your_industry"
                            selected={selected}
                            onChange={onChange}
                            industries={currentUserIndustries}
                            displayAllIndustries={isEmpty(commonIndustries)}
                        />
                        {!isEmpty(currentUserIndustries) && !isEmpty(commonIndustries) && <Dropdown.MenuDivider />}
                        <Entries
                            headerKey="reviews.filters.industries"
                            onChange={onChange}
                            selected={selected}
                            industries={commonIndustries}
                            displayAllIndustries
                        />
                    </Dropdown.Menu>
                }
            >
                <Trigger selected={selected} onClick={onClick} />
            </Dropdown>
        </div>
    );
};

IndustrySelection.propTypes = {
    currentUserIndustries: object,
    commonIndustries: object,
    selected: string,
    onChange: func,
    onClick: func,
    multipleFilters: bool,
};

export default withImpressions(IndustrySelection, impressionConfig);
